import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

function Article() {
    const { slug } = useParams();  // Ottiene lo slug dall'URL
    const [article, setArticle] = useState(null);

    useEffect(() => {
        const fetchArticle = async () => {
            try {
                const response = await fetch(`https://psicopatici.com/public/api/v1/posts/${slug}`); // URL dell'API per un singolo articolo
                const data = await response.json();
                setArticle(data.data);  // Aggiorna lo stato con i dati dell'articolo
            } catch (error) {
                console.error('Errore durante il fetch dell\'articolo:', error);
            }
        };

        fetchArticle();
    }, [slug]);  // Effettua il fetch ogni volta che cambia lo slug

    // Restituisci un loader o un messaggio di errore se l'articolo non è ancora caricato
    if (!article) {
        return <div>Loading...</div>;
    }

    return (
        <>
            <section className="breadcrumb_area">
                <img className="p_absolute bl_left" src="img/v.svg" alt="" />
                <img className="p_absolute bl_right" src="img/home_one/b_leaf.svg" alt="" />
                <img className="p_absolute star" src="img/home_one/banner_bg.png" alt="" />
                <img className="p_absolute wave_shap_one" src="img/blog-classic/shap_01.png" alt="" />
                <img className="p_absolute wave_shap_two" src="img/blog-classic/shap_02.png" alt="" />
                <img className="p_absolute one wow fadeInRight" src="img/home_one/b_man_two.png" alt="" />
                <img className="p_absolute two wow fadeInUp" data-wow-delay="0.2s" src="img/home_one/flower.png" alt="" />
                <div className="container custom_container">
                    <form action="#" className="banner_search_form banner_search_form_two">
                        <div className="input-group">
                            <input type="search" className="form-control" placeholder='Search ("/" to focus)' />
                            <div className="input-group-append">
                                <select className="custom-select" id="inlineFormCustomSelect">
                                    <option selected>All Categories</option>
                                    {/* Opzioni di categoria dinamiche possono essere aggiunte qui */}
                                </select>
                            </div>
                            <button type="submit"><i className="icon_search"></i></button>
                        </div>
                    </form>
                </div>
            </section>
            <section className="page_breadcrumb">
                <div className="container custom_container">
                    <div className="row">
                        <div className="col-sm-7">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item"><a href="/articles">Articles</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">{article.name}</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-sm-5">
                            <a href="#" className="date"><i className="icon_clock_alt"></i>Updated on {new Date(article.updated_at).toLocaleDateString()}</a>
                        </div>
                    </div>
                </div>
            </section>
            <section className="doc_documentation_area" id="sticky_doc">
                <div className="overlay_bg"></div>
                <div className="container custom_container">
                    <div className="row">
                        <div className="col-lg-9 col-md-8">
                            <div id="post" className="documentation_info">
                                <article className="documentation_body" id="documentation">
                                    <div className="shortcode_title">
                                        <h1>{article.name}</h1>
                                        <p><span>Category: {article.categories.map(category => category.name).join(', ')}</span></p>
                                    </div>
                                    <div dangerouslySetInnerHTML={{ __html: article.description }} />
                                </article>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 doc_right_mobile_menu">
                            <div className="open_icon" id="right">
                                <i className="arrow_carrot-left"></i>
                                <i className="arrow_carrot-right"></i>
                            </div>
                            <div className="doc_rightsidebar scroll">
                                <nav className="list-unstyled doc_menu" id="navbar-example3">
                                    {/* Se il contenuto dell'articolo è diviso in sezioni, puoi aggiungere qui i link di navigazione */}
                                    <a href="#documentation" className="nav-link active">Documentation</a>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Article;
